export const VKONTAKTE = 'vkontakte';
export const TWITTER = 'twitter';
export const ODNOKLASSNIKI = 'odnoklassniki';
export const MAILRU = 'mailru';
export const GOOGLE = 'google';
export const APPLE = 'apple';
